<div class="site-sequencer-container">
    <div class="page-header sequence-builder-header" [ngClass]="{'sequence-logs-header': isSequenceTabSelected}"
    *ngIf="builderMode === 'sequence_builder'" id="site-sequencer-header">
        <div class="pull-left" [ngClass]="{'sequence-logs-header-inner': isSequenceTabSelected}">
            <div class="input-fields-container">
                <!-- Site selection dropdown -->
                <div class="site-selection-dropdown-wrapper" *ngIf="isInternalPortal && !isSitesLoading">
                    <app-site-selection-dropdown class="enable-site-selection" [items]="sites"
                    [config]="singlesiteSelectionDropdownConfig" [value]="selectedSiteId"
                    (selectionChange)="onSiteSelectionDropdownChange($event)"></app-site-selection-dropdown>
                </div>
                <!-- Search input field for dry run sequence logs modal -->
                <div class="search-container scope-list-search" *ngIf="isSequenceTabSelected">
                    <mat-form-field class="search-input">
                        <input matInput placeholder="Search" #searchTextField (keyup)="searchSequenceLogs(searchTextField?.value)"
                            autocomplete="off" />
                        <i class="fas fa-search" matPrefix aria-hidden="true"></i>
                    </mat-form-field>
                </div>
            </div>

            <!-- Log level type indicator for dry run sequence logs modal -->
            <div class="header-icons-container" *ngIf="isSequenceTabSelected">
                <app-error-type-legends></app-error-type-legends>
            </div>
        </div>
       
        <!-- Category level (Cloud, CCU, Device) tabs -->
        <div class="level-tabs-container" *ngIf="selectedSite && builderMode === 'sequence_builder' && !isSequenceTabSelected"
            [class.tabs-click-disabled]="isSiteSelectionInProgress">
            <div class="navigation-tabs">
                <mat-tab-group class="level-tabs" animationDuration="0ms" fitInkBarToContent="true"
                    [(selectedIndex)]="categoryMenu.activeTabIndex" (selectedTabChange)="toggleCategoryLevelTab($event)">
                    <ng-container *ngFor="let levelTab of categoryMenu.tabs">
                        <mat-tab 
                            [label]="levelTab.label" 
                            matTooltip="{{levelTab.label}}" 
                            matTooltipPosition='above'>
                        </mat-tab>
                    </ng-container>
                </mat-tab-group>
            </div>
        </div>
       
        <div class="pull-right p-r-10" *ngIf="!isSequenceTabSelected">
            <div class="inner-container" *ngIf="showSequenceActionButtons">
                <button mat-button class="sequence-lib-btn" color="primary"
                    [matMenuTriggerFor]="menu" (menuOpened)="setUpdatedFunctionsBlockData()" (click)="clearFilterSearch(); $event.stopPropagation();" (menuClosed)="sequenceBlocksPoolClosed()"  id="custom-block-btn">
                    SEQUENCE LIBRARY
                </button>
    
                <mat-menu #menu="matMenu" xPosition="before" [hasBackdrop]="false" class="custom-blocks-menu">
                    <ul (click)="$event.stopPropagation()" class="dropdown-menu-ul" id="custom-blocks-dropdown">

                        <ng-container *ngIf="isListRefreshInProgress; else menuContent">
                            <div class="loader-column custom-blocks-loading p-t-12 p-b-12">
                            <ngx-skeleton-loader
                                count="8"
                                [theme]="{
                                'border-radius': '4px',
                                'height': '26px',
                                'background-color': '#eff0f1'
                                }">
                            </ngx-skeleton-loader>
                            </div>
                        </ng-container>

                        <ng-template #menuContent>

                            <div class="custom-blocks-panel" [hidden]="commentsPanelView">
                                <!-- Header -->
                                <div class="header-container">
                                    <div class="header-label">Custom Blocks</div>
                                </div>
                        
                                <!-- Sub-header -->
                                <div class="sub-header custom-blocks-sub-header m-t-12 m-b-8" [ngClass]="{ 'recommendation-active': isAISearchActive }">
                                    <div class="sub-header-left custom-blocks-sub-header-left">
                                        <div class="icon-box">
                                            <puc-common-search [inputPlaceholder]="'Search'" (enterKeyPress)="getAIRecommendedItems($event)"
                                                (searchText)="searchCustomBlocksOnDropDownList($event)" (clearSearch)="clearFilterSearch()"
                                                class="common-pool-search"></puc-common-search>
                                        </div>
                                        <span class="sub-header-text" *ngIf="!isAISearchActive && !recommendedAIItems?.length">
                                            Press Enter to get recommendations from <b>Saffron AI</b> <img alt="ai-icon" class="m-l-4"
                                                src="./assets/images/ai-recommendation-gradient.svg">
                                        </span>

                                        <!-- Quick Filters -->
                                        <div class="quick-filters-container" *ngIf="!isAISearchActive">
                                            <app-quick-filters [selectedFilters]="selectedQuickFilters"
                                                (selectedFiltersChange)="onQuickFiltersChange($event)"></app-quick-filters>
                                        </div>
                                        
                                    </div>
                                </div>
                    
                    
                                <ng-container id="custom-blocks-container">
                                    <div class="list-menu-functions">
                        
                                        <!-- AI Search Section -->
                                        <div *ngIf="isAISearchActive" class="ai-recommendation-section m-b-8">
                                            <ng-container>
                                                <div class="ai-recommendation-header">
                                                    <span class="ai-recommendation-text">Recommended by Saffron AI
                                                        <img alt="ai-icon" class="m-l-4"
                                                            src="./assets/images/ai-recommendation-gradient.svg"></span>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="!recommendedAIItems?.length && isAISearchLoading">
                                                <span class="no-recommended-result no-recommended-result-text recommended-loading">{{ loadingText
                                                    }}</span>
                                            </ng-container>
                        
                        
                                            <ng-container *ngIf="recommendedAIItems?.length && !isAISearchLoading"
                                                (click)="$event.stopPropagation();">
                                                <li class="recommendations-section-li recommendation-item bgc list-menu-function"
                                                    *ngFor="let item of recommendedAIItems; let i=index" (click)="$event.stopPropagation();"
                                                    aria-hidden="true" [ngClass]="{'dragging': isDraggingFunctionBlock}" cdkDropList
                                                    [cdkDropListData]="sequencerFunctionCollection">
                                                    <ng-container>
                                                        <div class="block-text-height" (mouseenter)="onOptionHover(item, true)"
                                                            (mouseleave)="onMouseOut()" id="block-text-height" cdkDrag
                                                            (cdkDragStarted)="onFunctionBlockDragStarted($event)"
                                                            (cdkDragEnded)="onFunctionBlockDragEnded($event, item)"
                                                            (cdkDragMoved)="handleCursorType('moved', $event)" [cdkDragData]="item"
                                                            [cdkDragPreviewClass]="'drag-preview'">
                        
                                                            <div class="block-name-container">
                                                                <img src="./assets/images/drag-block.svg" class="drag-block-icon" alt=""
                                                                    id="drag-block-icon">
                                                                <div class="block-lable-name" id="block-label-name"
                                                                    [pucCommonTooltip]="(tooltipData?.id === item?.functionId) ? tooltipData : null"
                                                                    placement="left">
                                                                    {{item?.seqFunctionName}}
                                                                </div>
                                                                <img *ngIf="item?.verified" class="community-badge-icon" src="./assets/images/community-badge.svg"
                                                                    alt="Community Approved" matTooltip="Community Approved" matTooltipPosition="above" matTooltipClass="community-tooltip"
                                                                    id="community-badge-icon">
                                                                <i *ngIf="!isSequenceFunctionCreatedByLoggedInUser(item)" class="fas shared-icon fa-users p-l-4" aria-hidden="true" id="personal-icon" matTooltip="Shared by others" matTooltipPosition="above"></i>
                                                                <i *ngIf="isSequenceFunctionCreatedByLoggedInUser(item)" class="fas shared-icon fa-share-alt p-l-4" aria-hidden="true" id="shared-icon" matTooltip="Shared by me" matTooltipPosition="above"></i>
                                                            </div>

                                                        
                                                            <div class="action-container"
                                                                [ngClass]="isSequenceFunctionCreatedByLoggedInUser(item) ? 'actionItemsPosition' : ''"
                                                                id="action-container">
                                                                <div class="p-l-2 p-r-5 likes-text" id="likes-text"
                                                                    [ngClass]="{ 'visibility-hidden': !(item?.noOfLikes > 0) }">
                                                                    <span
                                                                        [matTooltip]="(item?.noOfLikes > 999) ? item?.noOfLikes + ' Likes': null"
                                                                        [matTooltipPosition]="'above'">{{likeCountFormat(item?.noOfLikes)}}
                                                                        {{item?.noOfLikes == 1 ? 'Like':
                                                                        'Likes'}}</span>
                                                                </div>
                                                                <div *ngIf="!isSequenceFunctionCreatedByLoggedInUser(item)"
                                                                    [class.disableClick]="item.showLikeAnimation" class="like drop-down-icon p-r-3"
                                                                    (click)="updateBlockLikeBookmark('LIKE', item)" id="like-icon">
                                                                    <img *ngIf="item.likedByLoggedInUser && !item.showLikeAnimation" class="like-image like"
                                                                        src="./assets/images/selected-like.svg" alt="" id="liked-image">
                                                                    <img *ngIf="item.showLikeAnimation" class="like-animated-icon"
                                                                        src="./assets/images/like-animated-icon.gif" alt="like-anim"
                                                                        id="like-anim-icon">
                                                                    <img *ngIf="!item.likedByLoggedInUser && !item.showLikeAnimation" class="like-image"
                                                                        src="./assets/images/default-like.svg" alt=""
                                                                        id="default-like-image">
                                                                </div>
                                                                <div class="drop-down-icon p-l-2 p-r-5 bookmark"
                                                                    [class.disableClick]="item.showBookmarkAnimation" (click)="!item.showBookmarkAnimation && updateBlockLikeBookmark('BOOKMARK', item)" id="bookmark-icon">
                                                                    <img *ngIf="item.bookmarkedByLoggedInUser && !item.showBookmarkAnimation" class="like-image"
                                                                        src="./assets/images/bookmarksolid.svg" alt=""
                                                                        id="solid-bookmark-icon">
                                                                    <img *ngIf="item.showBookmarkAnimation"
                                                                        class="bookmark-animated-icon" src="./assets/images/bookmark-animated-icon.gif" 
                                                                        id="bookmark-anim-icon"  alt="bookmark-anim">
                                                                    <img *ngIf="!item.bookmarkedByLoggedInUser && !item.showBookmarkAnimation" class="like-image"
                                                                        src="./assets/images/bookmarkoutline.svg" alt=""
                                                                        id="regular-bookmark-icon">
                                                                </div>
                                                                
                                                                <!-- Comments icon for shared items -->
                                                                <div class="m-r-6 m-l-6 p-t-1 comments-section-wrapper">
                                                                    <div class="comments-icon-section" id="comment-icon" (click)="openCommentsPanel(item); $event.stopPropagation();">
                                                                        <i class="far fa-comment-alt comments-icon"></i>
                                                                        <span *ngIf="item.unreadCommentsExist" class="dot"></span>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="drop-down-icon p-l-3 p-r-3 bookmark-icon" id="filter-dialog-icon">
                                                                    <i *ngIf="isSequenceFunctionCreatedByLoggedInUser(item) && item.functionId == hoveredFunctionBlock?.functionId && enableTableEdit && hoveredOnRecommendedItem"
                                                                        class="fas fa-pen edit-icon color-primary" id="edit-icon"
                                                                        (click)="seqFunctionActionFromFlyout('edit', item)"></i>
                                                                    <i *ngIf="!isSequenceFunctionCreatedByLoggedInUser(item) && item.functionId == hoveredFunctionBlock?.functionId && enableTableEdit && hoveredOnRecommendedItem"
                                                                        class="fas fa-eye edit-icon color-primary" id="eye-icon"
                                                                        (click)="seqFunctionActionFromFlyout('view', item)"></i>
                                                                </div>
                                                            </div>
                        
                                                            <div *cdkDragPlaceholder class="field-placeholder"></div>
                                                        </div>
                        
                                                    </ng-container>
                        
                                                </li>
                        
                                            </ng-container>
                                            <ng-container *ngIf="!recommendedAIItems?.length && !isAISearchLoading">
                                                <div class="no-recommended-result">
                                                    <span class="no-recommended-result-header">Could not find a matching Custom Block.
                                                        Want to
                                                        create a new one?</span>
                                                    <span class="no-recommended-result-text">Click Create Custom Block to
                                                        begin.</span>
                                                </div>
                                            </ng-container>
                                        </div>
                                        
                                        <!-- Function Blocks List with Virtual Scroll -->
                                        <ng-container [ngTemplateOutlet]="cdkVirtualListTemplate" id="virtualScrollContainer" [ngTemplateOutletContext]="{ list: virtualFunctionsBlockList }"></ng-container>
                                    </div>
                                    <div class="create-btn" id="create-new-custom-block-btn" (click)="navigateToLibraryBuilder()">CREATE NEW
                                        CUSTOM BLOCK </div>
                                </ng-container>
                            </div>
                        
                            <!-- Comments Panel -->
                            <ng-container *ngIf="commentsPanelView">
                                <div class="sequence-pool-comments-container" (click)="$event.stopPropagation()">
                                    <app-comments-layout-wrapper [componentId]="activeCommentsPanelConfig.componentId"
                                        [componentName]="activeCommentsPanelConfig.componentName"
                                        [componentType]="activeCommentsPanelConfig.componentType"
                                        [layoutMode]="activeCommentsPanelConfig.layoutMode" [showWhiteHeader]="true" [componentOwnerId]="activeCommentsPanelConfig.componentOwnerId"
                                        (closePanel)="closeCommentsPanel(); $event.stopPropagation();"></app-comments-layout-wrapper>
                                </div>
                            </ng-container>

                        </ng-template>
                    </ul>
                </mat-menu>
                
                <!-- Virtual Scroll Template -->
                <ng-template #cdkVirtualListTemplate let-list="list">
                    @if (!isLoading) {
                    @if (list?.length) {
                    <cdk-virtual-scroll-viewport [style.height.px]="viewportHeight() > 0 ? viewportHeight() : null"
                        class="functions-virtual-viewport" [itemSize]="26" [minBufferPx]="300" [maxBufferPx]="400">
                        <ng-container *cdkVirtualFor="let row of list; let i=index; trackBy: trackById">
                
                            <!-- Accordion Header -->
                            <div class="accordion-header-title" *ngIf="row.type === 'header'">
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex" (click)="toggleAccordion(row.key)">
                                        <i [ngClass]="(row.isOpen) ? 'fa fa-angle-down arrow-down' : 'fa fa-angle-right arrow-right'"
                                            class="customDropdownIcon" aria-hidden="true"></i>
                                        <span class="sub-title" matTooltip="" matTooltipPosition='above' showTooltipOnOverflow>{{row.title}}</span>
                                    </div>
                                </div>
                            </div>
                
                            <!-- List Items -->
                            <li *ngIf="row.type === 'item'" class="div-bgcolor custom-block-list-item">
                                <ng-container [ngTemplateOutlet]="functionBlocksListRowTemplate"
                                    [ngTemplateOutletContext]="{ item: row.data, i: i, type: row.key }">
                                </ng-container>
                            </li>
                
                            <!-- Empty state -->
                            <ng-container *ngIf="row.type === 'empty'">
                                <div (click)="$event.stopPropagation();" id="noTablesDisplay" class="no-result p-l-58 p-t-8  p-b-8">
                                    {{row.message}}
                                </div>
                            </ng-container>
                        </ng-container>
                    </cdk-virtual-scroll-viewport>
                    }
                    } @else {
                    <div class="loader-column">
                        <ngx-skeleton-loader [theme]="{ 'border-radius': '0', 'height': '26px', 'background-color': '#eff0f1'}"
                            count="11">
                        </ngx-skeleton-loader>
                    </div>
                    }
                </ng-template>

                <ng-template #functionBlocksListRowTemplate let-item="item" let-i="i" let-type="type">
                    <ng-container>
                        <div class="block-text-height" (mouseenter)="onOptionHover(item, false)" (mouseleave)="onMouseOut()"
                            id="block-text-height" cdkDrag (cdkDragStarted)="onFunctionBlockDragStarted($event)"
                            (cdkDragEnded)="onFunctionBlockDragEnded($event, item)" (cdkDragMoved)="handleCursorType('moved', $event)"
                            [cdkDragData]="item" [cdkDragPreviewClass]="'drag-preview'">
                
                            <div class="block-name-container">
                                <img src="./assets/images/drag-block.svg" class="drag-block-icon" alt="" id="drag-block-icon">
                                <div class="block-lable-name" id="block-label-name"
                                    [pucCommonTooltip]="(tooltipData?.id === item?.functionId) ? tooltipData : null"
                                    placement="left">
                                    {{item?.seqFunctionName}}
                                </div>
                                <img *ngIf="item?.verified" class="community-badge-icon" src="./assets/images/community-badge.svg"
                                    alt="Community Approved" matTooltip="Community Approved" matTooltipPosition="above" matTooltipClass="community-tooltip"
                                    id="community-badge-icon">
                            </div>
                
                            <div class="action-container" [ngClass]="isSequenceFunctionCreatedByLoggedInUser(item) ? 'actionItemsPosition' : ''"
                                id="action-container">
                                <div class="p-l-2 p-r-5 likes-text" id="likes-text"
                                    [ngClass]="{ 'visibility-hidden': !(item?.noOfLikes > 0) }">
                                    <span [matTooltip]="item?.noOfLikes > 999 ? item?.noOfLikes + ' Likes': null"
                                        [matTooltipPosition]="'above'">{{likeCountFormat(item?.noOfLikes)}} {{item?.noOfLikes ==
                                        1 ? 'Like': 'Likes'}}</span>
                                </div>
                                <div *ngIf="!isSequenceFunctionCreatedByLoggedInUser(item)" class="like drop-down-icon p-r-3"
                                    (click)="updateBlockLikeBookmark('LIKE', item)" [class.disableClick]="item.showLikeAnimation"
                                    id="like-icon">
                                    <img *ngIf="item.likedByLoggedInUser && !item.showLikeAnimation" class="like-image"
                                        src="./assets/images/selected-like.svg" alt="" id="liked-image">
                                    <img *ngIf="item.showLikeAnimation" class="like-animated-icon"
                                        src="./assets/images/like-animated-icon.gif" id="like-anim-icon" alt="like-anim">
                                    <img *ngIf="!item.likedByLoggedInUser && !item.showLikeAnimation" class="like-image"
                                        src="./assets/images/default-like.svg" alt="" id="default-like-image">
                                </div>
                                <div class="drop-down-icon p-l-2 p-r-5 bookmark" (click)="updateBlockLikeBookmark('BOOKMARK', item)"
                                    [class.disableClick]="item.showBookmarkAnimation" id="bookmark-icon">
                                    <img *ngIf="item.bookmarkedByLoggedInUser && !item.showBookmarkAnimation" class="like-image"
                                        src="./assets/images/bookmarksolid.svg" alt="" id="solid-bookmark-icon">
                                    <img *ngIf="item.showBookmarkAnimation" class="bookmark-animated-icon"
                                        src="./assets/images/bookmark-animated-icon.gif" id="bookmark-anim-icon" alt="bookmark-anim">
                                    <img *ngIf="!item.bookmarkedByLoggedInUser && !item.showBookmarkAnimation" class="like-image"
                                        src="./assets/images/bookmarkoutline.svg" alt="" id="regular-bookmark-icon">
                                </div>
                                <!-- Comments icon -->
                                <div class="m-r-6 m-l-6 p-t-1 comments-section-wrapper">
                                    <div class="comments-icon-section" id="comment-icon"
                                        (click)="openCommentsPanel(item); $event.stopPropagation();">
                                        <i class="far fa-comment-alt comments-icon"></i>
                                        <span *ngIf="item.unreadCommentsExist" class="dot"></span>
                                    </div>
                                </div>
                                <div class="drop-down-icon p-l-3 p-r-3 bookmark-icon" id="filter-dialog-icon">
                                    <i *ngIf="isSequenceFunctionCreatedByLoggedInUser(item) && item.functionId == hoveredFunctionBlock?.functionId && enableTableEdit && !hoveredOnRecommendedItem"
                                        class="fas fa-pen edit-icon color-primary" id="edit-icon"
                                        (click)="seqFunctionActionFromFlyout('edit', item)"></i>
                                    <i *ngIf="!isSequenceFunctionCreatedByLoggedInUser(item) && item.functionId == hoveredFunctionBlock?.functionId && enableTableEdit && !hoveredOnRecommendedItem"
                                        class="fas fa-eye edit-icon color-primary" id="eye-icon"
                                        (click)="seqFunctionActionFromFlyout('view', item)"></i>
                                </div>
                            </div>
                
                            <div *cdkDragPlaceholder class="field-placeholder"></div>
                        </div>
                    </ng-container>
                </ng-template>
            </div>
        </div>

    </div>

    <div class="page-header library-builder-header" *ngIf="builderMode === 'library_builder'">
        <div class="pull-left">
            <button mat-button class="action-btn" color="primary" (click)="navigateBackToSiteSequences()" id="back-to-sites-btn">
                Back to Site Sequences
            </button>
        </div>

        <div class="pull-right" *ngIf="!isWorkspaceReadOnly">
            <button mat-button class="action-btn" color="primary"
                *ngIf="!isBuildingNewSequenceFunction && !isDuplicatingSequenceFunction && selectedFunctionToView"
                (click)="seqFunctionActionFromFlyout('delete', selectedFunctionToView)" id="delete-sequence-btn">
                Delete
            </button>
            <button mat-button class="action-btn" color="primary" (click)="clearWorkspace()" id="clear-workspace-btn">
                Clear
            </button>
            <button mat-button class="action-btn" color="primary" *ngIf="isBuildingNewSequenceFunction"
                (click)="saveSequenceFunction()" id="create-new-sequence-btn">
                Create
            </button>
            <button mat-button class="action-btn" color="primary" *ngIf="!isBuildingNewSequenceFunction"
                (click)="saveAndUpdateSequenceFunction()" id="update-sequence-btn">
                Update
            </button>
            <button mat-button class="action-btn" color="primary" id="duplicate-sequence-btn"
                *ngIf="!isBuildingNewSequenceFunction && !isDuplicatingSequenceFunction && selectedFunctionToView"
                (click)="duplicateSequenceFunction()">
                Create As New
            </button>
        </div>    
    
        <div class="pull-right" *ngIf="!isBuildingNewSequenceFunction && (isWorkspaceReadOnly)">
            <button mat-button class="action-btn" color="primary"
                *ngIf="isSequenceFunctionCreatedByLoggedInUser(selectedFunctionToView)" (click)="enableEditSequence()" id="edit-sequence-btn">
                Edit
            </button>
            <button mat-button *ngIf="isWorkspaceReadOnly" [disabled]="true" class="action-btn" color="primary"
                (click)="clearWorkspace()" id="clear-btn">
                Clear
            </button>
            <button mat-button class="action-btn" color="primary"
                *ngIf="!isDuplicatingSequenceFunction && !isSequenceFunctionCreatedByLoggedInUser(selectedFunctionToView)"
                (click)="duplicateSequenceFunction()" id="create-new-sequence-btn">
                Create As New
            </button>
        </div>
    </div>
    <button #showHideButton class="showHideButton" [ngClass]="{'toolboxActive': showToolBox, 'hide-expand-cta': !featureAccessible}"
        (click)="showHideToolBox(!showToolBox)" mat-fab *ngIf="showToolBoxToggleButton" id="show-tool-box" [disabled]="!featureAccessible">
        <i class="btn-icon" [ngClass]="this.showToolBox ? 'fas fa-chevron-left' : 'fas fa-chevron-right'"></i>
    </button>

    <div class="main-content default-workspace">
        <div class="workspace-header" [ngClass]="{'toolboxActive': showToolBox}">
            <div class="breadcrumbs-container" *ngIf="categoryMenu.selectedCategory.id !== 'DEVICE'">
                <div class="breadcrumb-label-wrapper" *ngFor="let seq of breadcrumbs" (click)="getBlockIntoView(seq, true)">
                    <span class="breadcrumb-label">
                        {{ seq.seqName }}
                    </span>
                </div>
            </div>
            <!-- Warning text on workspace in device category -->
            <div class="workspace-warning-text"
                *ngIf="showWorkspaceWarningText && builderMode === 'sequence_builder' && categoryMenu.selectedCategory.id === 'DEVICE'">
                <div class="warning-icon-container">
                    <img class="warning-icon" src="./assets/images/warning-error-icon.svg" alt="warning-icon">
                </div>
                <div class="error-text">The updated sequence has been saved but has not been applied to all the selected zones.</div>
            </div>
            <div class="pull-right workspaceBtn" *ngIf="showSequenceActionButtons && builderMode === 'sequence_builder'">
                <button mat-button class="action-btn" color="primary" id="ccu_logs-btn" *ngIf="categoryMenu.selectedCategory.id === 'DEVICE' && noChangesInWorkspace" (click)="openDebugInfoModal()">
                    DEBUG INFO
                </button>
                <button mat-button class="action-btn" color="primary" id="download-btn" *ngIf="categoryMenu.selectedCategory.id === 'DEVICE' && noChangesInWorkspace" [disabled]="isPythonExecutionLoading" (click)="executePythonCode()">
                    Download
                </button>
                <button mat-button class="action-btn" color="primary" id="ccu_logs-btn" *ngIf="categoryMenu.selectedCategory.id === 'DEVICE' && noChangesInWorkspace" [disabled]="isPythonExecutionLoading" (click)="openPushToDeviceModal()">
                    PUSH TO DEVICES
                </button>
                <button mat-button class="action-btn" color="primary" id="ccu_logs-btn" *ngIf="categoryMenu.selectedCategory.id === 'CCU'"
                    (click)="openCCULogsModal()">
                    CCU Logs
                </button>
                <ng-container *ngIf="categoryMenu.selectedCategory.id != 'DEVICE'">
                    <button mat-button class="action-btn" color="primary" (click)="loadSavedState()" id="cancel-btn"
                    [disabled]="isLoadingSavedState || isLoading">
                        Cancel
                    </button>
                    <button [disabled]="noChangesInWorkspace" mat-button class="action-btn" color="primary" (click)="validateAndSaveSequence()" id="save-sequence-btn">
                        {{categoryMenu.selectedCategory.id === 'CLOUD' ?  'Save & Run' : 'Save'}}
                    </button>
                </ng-container>
                <ng-container *ngIf="categoryMenu.selectedCategory.id == 'DEVICE' && !noChangesInWorkspace">
                    <button mat-button class="action-btn" color="primary" (click)="loadSavedState()" id="cancel-btn"
                    [disabled]="isLoadingSavedState || isLoading">
                        Cancel
                    </button>
                    <button mat-button class="action-btn" color="primary" (click)="validateAndSaveSequence()" id="save-sequence-btn">
                        Save
                    </button>
                </ng-container>
               
            </div>
        </div>    

        <div class="col-12 no-building placeholder-text"
            *ngIf="builderMode === 'sequence_builder' && placeholderMessage">
            <i class="fas fa-building fa-5x" aria-hidden="true" *ngIf="!selectedSite"></i>
            <div class="message-text">{{placeholderMessage}}</div>
        </div>
        <div class="workspace-wrapper" *ngIf="!isSequenceTabSelected && selectedSite">
            <div class="blockly-container" [id]="blocklyContainerId"></div>
            <div class="codeSnippetContainer"
                [ngClass]="{'expanded': isCodeBlockVisible}"
                [style.height.px]="isCodeBlockVisible ? codeSnippetHeight : 25">
                <div class="code-snippet-resize-handle" (mousedown)="startCodeSnippetResize($event)"></div>
                <div class="code-snippet-inner">
                    <button #showHideCodeBlock class="showHideCodeBlock" matTooltipClass="codeBlockTooltip"
                        #tooltip="matTooltip" [matTooltip]="codeBlockTooltipText" matTooltipPosition="above"
                        (click)="showHideCodeSnippetBlock()" mat-fab>
                        <i class="btn-icon"
                            [ngClass]="isCodeBlockVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                    </button>
                    <div class="code-snippet-block">
                        <ngx-codemirror *ngIf="isCodeBlockVisible" [(ngModel)]="code" [options]="{
                          lineNumbers: true,
                          theme: 'default',
                          mode: 'markdown',
                          readOnly : true
                        }"></ngx-codemirror>
                    </div>
                </div>
            </div>
        </div>
        <div class="sequence-logs-wrapper" *ngIf="isSequenceTabSelected">
            <app-site-sequencer-table [isLoading]="isLoading" [sitetimeZone]="selectedSite?.tz" [table]="sequenceLogstableData" [hideTableHeader]="true"
                [headerColumns]="sequenceLogsHeaderColumns" [searchedSequenceLogsValue]="searchedSequenceLogsValue">
            </app-site-sequencer-table>
        </div>
        <div class="sequence-tabs-container">
            <div class="tabs-action-button-container"
                *ngIf="builderMode === 'sequence_builder' && ((canvasTabs.tabs.length || sequenceTabs.length) || isSearchActive)">
                <button *ngIf="!isSearchActive" mat-icon-button class="tab-action-button search-icon"
                    (click)="searchbtnClicked()">
                    <i class="fa fa-search icon"></i>
                </button>
                <mat-form-field *ngIf="isSearchActive" class="canvas-search-input">
                    <input #workspaceTabsSearchInput class="canvas" [(ngModel)]="searchText" (ngModelChange)="searchSequence(searchText)" (blur)="closeSearch()" type="text"
                        matInput placeholder="Search for canvas" autofocus>
                    <i class="fa fa-search input-search-icon" matPrefix aria-hidden="true"></i>
                    <i (click)="clearCanvasSearch()" class="fa fa-times clear-search-icon" matSuffix aria-hidden="true"></i>
                </mat-form-field>
                <span class="seperator-line">|</span>
                <button [disabled]="isCreateCanvasLoading" mat-icon-button class="tab-action-button create-tab"
                    (click)="createNewCanvasTab()">
                    <i class="fa fa-plus icon"></i>
                </button>
            </div>
            <div class="no-canvas-text" *ngIf="builderMode === 'sequence_builder' && !canvasTabs.tabs.length && !sequenceTabs.length && !isLoading && siteId.length">
                No workspace found
            </div>

            <!-- Default Tab with sequence function name in the Library builder -->
            <div *ngIf="builderMode === 'library_builder'" class="tabs-container">
                <div class="tab active">
                    <div class="tab-inner-container">
                        <span class="tab-label">
                            {{defaultTabLabel}}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Canvas and Sequence Tabs in the Sequence builder -->
            <div *ngIf="builderMode === 'sequence_builder'" class="tabs-container">
                <div class="tab" *ngFor="let canvasTab of canvasTabs.tabs;let index = index;"
                    [ngClass]="{'active': (canvasTab.id == canvasTabs.selectedCanvasTab?.id) && !isSequenceTabSelected }"
                    (dblclick)="canvasDblClicked(canvasTab)" (contextmenu)="openMenu($event, canvasTab)"
                    (click)="canvasClicked(canvasTab)">
                    <div class="tab-inner-container">
                        <div class="tab-label" *ngIf="!canvasTab?.isCanvasNameEdit" 
                            matTooltip="" matTooltipPosition='above' showTooltipOnOverflow>
                            {{canvasTab.name}}
                        </div>
                        <div *ngIf="canvasTab.isCanvasNameEdit">
                            <input #renameInput class="rename-input" [(ngModel)]="canvasTab.tempName" (blur)="renameCanvasText(canvasTab)"  maxlength="40" type="text" matInput
                            (click)="$event.stopPropagation()" placeholder="Search for canvas" autofocus>
                        </div>
                    </div>
                
                    <div *ngIf="canvasTab.showMenu" class="menu-container" [style.left.px]="contextMenuPostion.x">
                        <div (click)="showRenameCanvasInput(canvasTab, $event)" class="menu-option-text">
                            Rename
                        </div>
                        <div (click)="deleteCanvas(canvasTab, $event)" class="menu-option-text">
                            Delete
                        </div>
                    </div>
                </div>
                <div class="tab" *ngFor="let sequenceTab of sequenceTabs"
                    [ngClass]="{'active': (sequenceTab.seqId == selectedSequenceTab?.seqId) && isSequenceTabSelected }"
                    (click)="getSelectedSequenceTab(sequenceTab)">
                    <div class="tab-inner-container">
                        <div class="tab-label" matTooltip="" matTooltipPosition='above' showTooltipOnOverflow>
                            {{sequenceTab.seqName}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-loader *ngIf="isLoading || isLoadingSavedState || isPythonExecutionLoading"></app-loader>
</div>

<ng-template #saveSeqFunctionDialog>
  <div class="save-seq-function-dialog">
    <div class="save-seq-function-dialog-header">
        <span class="dialog-title">{{ isProcedureSeqFunctionUpdateMode ? 'Edit Sequence Library Function' : (isProcedureSeqFunctionCreateAsNewMode ? 'Create As New Sequence Library Function' : 'Save to Sequence Library') }}</span>
        <span class="dialog-subtitle">Please provide details to {{ isProcedureSeqFunctionUpdateMode ? 'edit' : (isProcedureSeqFunctionCreateAsNewMode ? 'create as new' : 'save') }} this function.</span>
    </div>

    <div class="seq-function-name-input-container">
        <mat-form-field appearance="fill" class="full-width seq-function-name-input">
          <input matInput 
            [value]="saveSeqFunctionForm.name" 
            placeholder="Sequence function name"
            (input)="saveSeqFunctionForm.name = $any($event.target).value; onSeqFunctionDialogInputChange()">
        </mat-form-field>
    </div>

    <div class="seq-function-description-container">
        <div class="description-field-container">
            <div class="desc-label-container">
                <label class="description-field-label">Why</label>
            </div>
            <mat-form-field matInput appearance="fill" class="full-width description-field">
                <textarea class="description-input" 
                    matInput 
                    rows="3" 
                    placeholder="Type in description here"
                    [value]="saveSeqFunctionForm.why" 
                    (input)="saveSeqFunctionForm.why = $any($event.target).value; onSeqFunctionDialogInputChange()">
                </textarea>
            </mat-form-field>
        </div>
        
        <div class="description-field-container">
            <div class="desc-label-container">
                <label class="description-field-label">What</label>
            </div>
            <mat-form-field matInput appearance="fill" class="full-width description-field">
                <textarea class="description-input" 
                    matInput 
                    rows="3"
                    placeholder="Type in description here" 
                    [value]="saveSeqFunctionForm.what" 
                    (input)="saveSeqFunctionForm.what = $any($event.target).value; onSeqFunctionDialogInputChange()">
                </textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="error-text" *ngIf="saveSeqFunctionError">{{ saveSeqFunctionError }}</div>

    <div class="dialog-actions">
      <button mat-button (click)="closeSaveSeqFunctionDialog()">Cancel</button>
      <div class="action-btn-divider"></div>
      <button mat-raised-button color="primary" (click)="saveProcedureAsSequenceFunction()" [disabled]="isSavingSeqFunctionFromProcedure">
        {{ isSavingSeqFunctionFromProcedure
          ? (isProcedureSeqFunctionUpdateMode ? 'Updating...' : 'Saving...')
          : (isProcedureSeqFunctionUpdateMode ? 'Update' : (isProcedureSeqFunctionCreateAsNewMode ? 'Create As New' : 'Save')) }}
      </button>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="!featureAccessible && !isLoading && billingAdminDetails">
    <div class="site-sequencer-ovrlay-ctnr">
        <div>
            <access-restriction-popup [componentName]="'Site Sequencer'"  [isBillingAdmin]="billingAdminDetails?.isBillingAdmin" [restrictionType]="restrictionType"  [siteBillingAdmins]="billingAdminDetails?.siteBillingAdmins" [userInfo]="userInfo">
            </access-restriction-popup>
        </div>
    </div>
  </ng-container>
